import { ClInputContainerController } from './ClInputContainerDirective';

/* Anything that goes in here will be appended by the ClInputContainer directive,
 * this is necessary to maintain scope &  prevent double compilation. This should be used for things like:
 * md-tooltip
 * extra information (units for numberSensorInput)
 */

export class ClExtrasDirective implements angular.IDirective {
    public static $name: string = 'clExtras';
    public restrict: string = 'E';

    /* Prevent the content from being compiled so we can do it ourselves later */
    public terminal: boolean = true;

    public require: string = '^clInputContainer';

    public link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, controller: ClInputContainerController) => {
        controller.extras = element.children();
        element.remove();
    }

    public static Factory() {
        let directive = () => {
            return new ClExtrasDirective();
        };

        directive['$inject'] = [];

        return directive;
    }
}
